import { client } from "@client/client";
import { CalculateCardProjectionsProps, StorageKey, UserQuery } from "@ctypes";
import { USER } from "@graphql";
import { convertCentsToDollar } from "./formatter";
import { US_STATE_ABBREVIATIONS } from "./trumpSidecar";

export const readUserFromCache = () => {
  const user = client.readQuery<UserQuery>({
    query: USER,
  });

  if (user) {
    localStorage.setItem(StorageKey.User, JSON.stringify(user));
    return user;
  }
  return undefined;
};

/**
 * Resolves the two letter state code used for the sidecar state tax estimate.
 * Mobile derives this from IP geolocation; on web we already collect the
 * residential address during onboarding, so prefer that and fall back to the
 * tax residency on file.
 */
export const getUserTaxState = (user?: UserQuery["user"]) => {
  const candidates = [user?.userAddress?.state, user?.userTaxProfiles?.[0]?.stateOfTaxResidence];

  return candidates
    .map((candidate) => candidate?.trim().toUpperCase())
    .find((candidate) => candidate && US_STATE_ABBREVIATIONS.has(candidate));
};

export const calculateCardProjections = ({ beneficiaries }: CalculateCardProjectionsProps) => {
  return (
    beneficiaries?.map((beneficiary) => {
      let currentAmount = 0;
      let projectedAmount = 0;

      beneficiary?.goals?.forEach((goal) => {
        currentAmount += convertCentsToDollar(goal?.currentAmountInCents);
        projectedAmount += convertCentsToDollar(goal?.targetAmountInCents);
      });

      return {
        id: beneficiary?.id,
        type: beneficiary?.type,
        name: beneficiary?.firstName ?? "",
        goalsLength: beneficiary?.goals?.length ?? 0,
        sipId: beneficiary?.goals?.[0]?.sips?.[0]?.id,
        currentAmount,
        projectedAmount,
      };
    }) ?? []
  );
};
